// pace-http.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class PaceHttpInterceptor implements HttpInterceptor {
  private excludedUrlPatterns: string[] = [
    '/service/dashboard',
    // Add more URL patterns to exclude here
  ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Backup history and live logs poll every two seconds. Let those requests
    // update the page without starting Pace's full-screen blocking overlay.
    if (/\/database-backups(?:\/|\?|$)/.test(request.url)) {
      return new Observable(subscriber => {
        const subscribe = () => next.handle(request).subscribe(subscriber);
        return window['Pace']?.ignore ? window['Pace'].ignore(subscribe) : subscribe();
      });
    }

    // Check if request URL should be excluded from Pace
    const shouldExclude = this.excludedUrlPatterns.some(pattern => request.url.includes(pattern));

    if (shouldExclude) {
      // Stop Pace before making the request
      this.disablePaceTemporarily();
    }

    // Proceed with the request
    return next.handle(request).pipe(
      finalize(() => {
        // Re-enable Pace after the request completes (if it was disabled)
        if (shouldExclude) {
          this.reenablePace();
        }
      })
    );
  }

  private disablePaceTemporarily() {
    if (window['Pace']) {
      window['Pace']._paceDisabledTemporarily = true;
      window['Pace'].stop();
    }
  }

  private reenablePace() {
    if (window['Pace'] && window['Pace']._paceDisabledTemporarily) {
      delete window['Pace']._paceDisabledTemporarily;
    }
  }
}
